import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import Api from "../../../../shared/api/api";
import "../styles/Auth.css";

export default function LoginPage() {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = Api.token;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setLoggedInUser(decoded.username || decoded.user || null);
      } catch (e) {
        console.error("Token decode error:", e);
      }
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const res = await Api.request("auth/token", formData, "post");
      Api.setToken(res.token);
      localStorage.setItem("token", res.token);
      const decoded = jwtDecode(res.token);
      setLoggedInUser(decoded.username);
      setError(null);
      navigate("/admin");
      window.location.reload();
    } catch (err) {
      setError("Invalid username or password.");
    }
  }

  function handleChange(evt) {
    const { name, value } = evt.target;
    setFormData(f => ({ ...f, [name]: value }));
  }

  return (
    <div className="auth-container">
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit} className="auth-form">
        <input
          name="username"
          placeholder="Username"
          value={formData.username}
          onChange={handleChange}
          disabled={!!loggedInUser}
          required
        />
        <input
          name="password"
          placeholder="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          disabled={!!loggedInUser}
          required
        />
        <button type="submit" disabled={!!loggedInUser}>
          {loggedInUser ? `Logged in as ${loggedInUser}` : "Login"}
        </button>
        {error && <p className="auth-error">{error}</p>}
      </form>
      {!loggedInUser && (
        <div className="auth-link">
          <a href="/reset-password">Forgot your password?</a>
        </div>
      )}
    </div>
  );
}
